import SkeletonListItem from './SkeletonListItem';

export default SkeletonListItem;
